import dayjs from 'dayjs';

import { DEFAULT_DATE_FORMAT } from '@/common/constants';
import regexp from '@/common/regexp';

const isValidDate = (date?: string) => {
  if (!date) {
    return false;
  }

  if (!regexp.DEFAULT_DATE_FORMAT.test(date)) {
    return false;
  }

  return dayjs(date, DEFAULT_DATE_FORMAT, true).isValid();
};

export default isValidDate;
